import abhaSlice from "./slices/abhaSlice";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
// import userReducer from "./path/to/UserSlice"; // your UserSlice

const rootReducer = combineReducers({
  user: abhaSlice,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
